module.exports = __webpack_public_path__ + "img/hotel13.78106105.png";